import React, { Component } from 'react';
import { Flex, Heading, Text, Button, Card } from 'core/components';

class KbToolResult extends Component {
  render() {
    const { tool, onCloseToolResult } = this.props;
    const { raw_result = {} } = tool;

    return (
      <Card
        p={0}
        className="tool-result-kb"
        display="flex"
        flexDirection="column"
        gap={2}
        height="100%"
        maxHeight={600}
        overflow="auto"
      >
        <Flex alignItems="center" justifyContent="space-between" p={2} pb={0}>
          <Heading level={5} m={0} flex={1}>
            {tool.title || 'Knowledge Base Result'}
          </Heading>
          <Flex alignItems="center" gap={1}>
            <Button text="Close" small icon="cross" onClick={() => onCloseToolResult(tool)} color="muted" minimal />
          </Flex>
        </Flex>

        <Flex p={1} flexDirection="column" gap={0}>
          {raw_result?.map((source) => (
            <Flex flexDirection="column" key={`${source.article}/${source.heading}`} p={1} borderBottom="thin">
              <Text>
                <a href={source.url} target="_blank" rel="noreferrer">
                  {source.article ? `${source.article} - ${source.heading}` : source.url}
                </a>
              </Text>
              <Text muted small>
                Similarity: {Math.round(source.similarity * 100)}%
              </Text>
            </Flex>
          ))}
        </Flex>
      </Card>
    );
  }
}

export default KbToolResult;
